import { RiskProfile } from 'actions';

const initialState = {
  riskProfileId: null,
  monitoredAccountIds: [],
  updateSuccess: false,
  updateError: null,
  isFetching: false,
  aggregate: [],
  currentPageInputSaved: true,
  riskProfile: null,
  riskProfileError: null,
  selectedPortfolio: null,
  monitoringResult: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RiskProfile.RISK_PROFILE_REQUEST:
      return {
        ...state,
        isFetching: true,
        riskProfileError: null,
      };
    case RiskProfile.RISK_PROFILE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        riskProfile: action.payload,
      };
    case RiskProfile.RISK_PROFILE_FAILURE:
      return {
        ...state,
        isFetching: false,
        riskProfileError: action.error,
      };
    case RiskProfile.SET_SELECTED_PORTFOLIO:
      return {
        ...state,
        selectedPortfolio: action.portfolioName,
      };
    case RiskProfile.SET_RISK_PROFILE:
      return {
        ...state,
        riskProfileId: action.payload,
      };
    case RiskProfile.SET_MONITORED_ACCOUNTS:
      return {
        ...state,
        monitoredAccountIds: action.payload,
      };
    case RiskProfile.RISK_PROFILE_MONITORING_SUCCESS:
    case RiskProfile.CREATE_RISK_PROFILE_MONITORING_SUCCESS:
    case RiskProfile.UPDATE_RISK_PROFILE_MONITORING_SUCCESS:
      return {
        ...state,
        updateSuccess: true,
        updateError: null,
        monitoringResult: action.payload,
      };
    case RiskProfile.RISK_PROFILE_MONITORING_FAILURE:
    case RiskProfile.CREATE_RISK_PROFILE_MONITORING_FAILURE:
    case RiskProfile.UPDATE_RISK_PROFILE_MONITORING_FAILURE:
      return {
        ...state,
        updateSuccess: false,
        updateError: action.payload,
      };

    default:
      return state;
  }
}
